import React, { useEffect } from "react";
import { ChevronRight, Star, Truck, X } from "lucide-react";
import i18next from "i18next";

const COPY = {
  ru: {
    title: "Быстрый доступ",
    saved: "Сохранённые заказы",
    savedDesc: "Избранные грузы для быстрого возврата",
    vehicles: "Мои машины",
    vehiclesDesc: "Созданные машины и управление объявлениями",
    close: "Закрыть",
  },
  uz: {
    title: "Тезкор кириш",
    saved: "Сақланган буюртмалар",
    savedDesc: "Тез қайтиш учун танланган юклар",
    vehicles: "Менинг машиналарим",
    vehiclesDesc: "Яратилган машиналар ва эълонларни бошқариш",
    close: "Ёпиш",
  },
  tr: {
    title: "Hızlı erişim",
    saved: "Kaydedilen yükler",
    savedDesc: "Hızlı dönüş için favori yükler",
    vehicles: "Araçlarım",
    vehiclesDesc: "Oluşturulan araçlar ve ilan yönetimi",
    close: "Kapat",
  },
};

function langCode() {
  const raw = String(i18next.language || "").toLowerCase();
  if (raw.startsWith("uz")) return "uz";
  if (raw.startsWith("tr")) return "tr";
  return "ru";
}

export default function DriverQuickAccessSheet({ open, onClose, onSaved, onVehicles }) {
  const copy = COPY[langCode()] || COPY.ru;

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  const choose = (handler) => {
    onClose?.();
    handler?.();
  };

  return (
    <div className="fixed inset-0 z-[10090] flex items-end justify-center" role="dialog" aria-modal="true" aria-label={copy.title}>
      <button type="button" className="absolute inset-0 bg-black/55" onClick={onClose} aria-label={copy.close} />
      <div className="relative w-full max-w-[760px] rounded-t-[28px] border border-slate-700 bg-slate-900 px-4 pb-[max(24px,env(safe-area-inset-bottom))] pt-3 shadow-2xl"
        data-reisor-theme-surface="driver-quick-access">
        <div className="mx-auto mb-2 h-1.5 w-14 rounded-full bg-slate-600" />
        <div className="flex items-center justify-between px-1 py-3">
          <h2 className="text-2xl font-black text-white">{copy.title}</h2>
          <button type="button" onClick={onClose} className="flex h-10 w-10 items-center justify-center rounded-xl text-slate-400" aria-label={copy.close}>
            <X size={22} />
          </button>
        </div>
        <div className="space-y-2">
          <button type="button" onClick={() => choose(onSaved)} className="flex w-full items-center gap-4 rounded-2xl border border-slate-700 bg-slate-950/70 p-4 text-left">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-amber-500 text-slate-950"><Star size={25} fill="currentColor" /></span>
            <span className="min-w-0 flex-1">
              <span className="block text-lg font-black text-white">{copy.saved}</span>
              <span className="mt-0.5 block text-sm text-slate-400">{copy.savedDesc}</span>
            </span>
            <ChevronRight size={23} className="text-slate-500" />
          </button>
          <button type="button" onClick={() => choose(onVehicles)} className="flex w-full items-center gap-4 rounded-2xl border border-slate-700 bg-slate-950/70 p-4 text-left">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-blue-600 text-white"><Truck size={26} /></span>
            <span className="min-w-0 flex-1">
              <span className="block text-lg font-black text-white">{copy.vehicles}</span>
              <span className="mt-0.5 block text-sm text-slate-400">{copy.vehiclesDesc}</span>
            </span>
            <ChevronRight size={23} className="text-slate-500" />
          </button>
        </div>
      </div>
    </div>
  );
}
